<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <img
        v-if="currency == 'gbp'"
        class="currency-flag"
        src="@/assets/flags/GB.png"
      />
      <img
        v-if="currency == 'usd'"
        class="currency-flag"
        src="@/assets/flags/US.png"
      />
      <img
        v-if="currency == 'eur'"
        class="currency-flag"
        src="@/assets/flags/EU.png"
      />
      {{ currency.toUpperCase() }}
      <ul class="summary-data">
        <li>Total : {{ data.Total.toFixed(2) }}</li>
        <li>Paid : {{ data.Paid.toFixed(2) }}</li>
        <li>Balance : {{ data.Outstanding.toFixed(2) }}</li>
      </ul>
    </div>
  </div>
</template>
<script>
import moment from "moment";

export default {
  props: {
    data: Object,
    currency: String
  }
};
</script>
<style lang="scss" scoped>
.currency-flag {
  width: auto;
  vertical-align: text-bottom;
  margin-right: 10px;
}
.summary-data {
  list-style-type: none;
  margin: 0;
  padding: 10px;
}
</style>
